import withRequiredAdmin from '../../HOC/withRequiredAdmin';
import AdminProducts from './AdminProducts';

export default withRequiredAdmin(AdminProducts);
